import {
  grey,
  white,
  black,
  red,
  green,
  yellow,
  indigo,
  brown,
  purple,
  lime,
  blue,
  teal,
  orange,
  pink,
  cider,
} from "sushiweb/tokens/color";

export default {
  primaryColor: red.z500,
  buttonColor: "#EF4F5F",
  TableHeadBackground: "#efefef",
  TableCellBackground: "#d4d4d4",
  secondaryColor: "#D3D3D3",
  primaryTextColor: black,
  secondaryTextColor: grey.z600,
  TableCellBorder: "1px solid #d4d4d4",
  pillColor: "#AFEEEE",
  borderColor: grey.z200,
  borderColor2: grey.z300,
  bgColor: "#F5F5F5",
  grey800: grey.z800,
  grey700: grey.z700,
  grey300: grey.z300,
  grey200: grey.z200,
  grey100: grey.z100,
  grey400: grey.z400,
  grey600: grey.z600,
  grey900: grey.z900,
  grey50: grey.z50,
  red500: red.z500,
  red600: red.z600,
  red900: red.z900,
  grey300: grey.z300,
  grey500: grey.z500,
  purple400: purple.z400,
  blue500: blue.z500,
  teal50: teal.z50,
  teal400: teal.z400,
  teal600: teal.z600,
  pink50: pink.z50,
  pink400: pink.z400,
  pink600: pink.z600,
  red50: red.z50,
  red300: red.z300,
  green300: green.z300,
  white: white,
  black: black,
  black900: black.z900,
  black800: black.z800,
  black700: black.z700,
  black600: black.z600,
  green500: green.z500,
  yellow500: yellow.z500,
  yellow400: yellow.z400,
  yellow50: yellow.z50,
  yellow600: yellow.z600,
  indigo500: indigo.z500,
  brown500: brown.z500,
  purple500: purple.z500,
  lime500: lime.z500,
  teal500: teal.z500,
  orange500: orange.z500,
  pink500: pink.z500,
  cider500: cider.z500,
  //breakpoints
  breakPoint1: "1024px",
  breakPoint2: 1024,

  //route vars
  routeEndpoint: "/zgw/dashboard/v1",
  sampleFileEndPoint: "/zgw",

  //ga-tracking
  trackingId: "UA-205467117-1",
};
